export default __webpack_public_path__ + "static/media/Scenografia.e44df047.jpg";